const parseExternalPostId = (id: string) => {
  const tokens = id.match(/([a-z]+)\/([^#]+)(?:#(.*))?/);
  if (!tokens) {
    return null;
  }

  const platform = tokens[1];
  const escapedExternalId = tokens[2];
  const anchor = tokens[3];
  const externalId = escapedExternalId
    ? decodeURIComponent(escapedExternalId)
    : undefined;

  return { platform, externalId, anchor };
};

export default parseExternalPostId;
